import React from 'react'
import PropTypes from 'prop-types'

import { ALL_COLORS, ALL_COLOR_NAMES } from '@cred/react-theme/colors'
import ComponentTag from '@cred/react-component-tag'

import styles from './styles.module.scss'
import Spinner from './spinner'
import withAnalytics from './components/withAnalytics'
import Icon from './components/Icon'
import * as packageJson from './package.json'

function CtaButton({
  color = 'primary',
  variant = 'contained',
  size = 'regular',
  href = null,
  showDisabled = false,
  loading = false,
  submit,
  children,
  className = '',
  leftIcon = null,
  rightIcon = null,
  componentTag = null,
  ...customProps
}) {
  const additionalClasses = []
  const capitalizedColor =
    ALL_COLORS[color].charAt(0).toUpperCase() + ALL_COLORS[color].substring(1)
  const Element = href ? 'a' : 'button'

  if (showDisabled) {
    additionalClasses.push(styles.disabled)
  }

  additionalClasses.push(`border${capitalizedColor}`)
  additionalClasses.push(styles[`border${capitalizedColor}`])

  let bgColor = `bg${capitalizedColor}`

  if (variant === 'outlined') {
    bgColor = 'bgWhite'
    additionalClasses.push(color === 'white' ? 'neutral700' : ALL_COLORS[color])
    additionalClasses.push(color === 'white' ? styles.neutral700 : styles[ALL_COLORS[color]])
  }

  /* Apply hover and siabled states from component styles */
  additionalClasses.push(styles[bgColor])

  /* Apply bg color from theme */
  additionalClasses.push(bgColor)

  if (size === 'small') {
    additionalClasses.push(styles.small)
    additionalClasses.push('bodySmall')
  }

  return (
    <Element
      href={href}
      className={`inlineFlex roundEdges ${additionalClasses.join(' ')} ${styles.cta} ${className}`}
      role={href ? undefined : 'button'}
      aria-disabled={showDisabled}
      {...componentTag}
      {...customProps}
    >
      <Icon content={leftIcon} />
      <span>{children}</span>
      {loading && <Spinner small={size === 'small'} />}
      <Icon content={rightIcon} />
    </Element>
  )
}

CtaButton.propTypes = {
  color: PropTypes.oneOf(ALL_COLOR_NAMES),
  variant: PropTypes.oneOf(['contained', 'outlined']),
  size: PropTypes.oneOf(['small', 'regular']),
  href: PropTypes.string,
  showDisabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  children: PropTypes.node.isRequired,
}

export default ComponentTag(packageJson, false)(withAnalytics(CtaButton))
